import { MultiLanguageText } from './MultiLanguageText';

export class BrowserItem {
  constructor(item = {}) {
    this.guid = item.guid || '-1';
    this.text = new MultiLanguageText(item.text);
    this.identification = item.identification || '';
  }
}
